import { MatDialogRef } from '@angular/material';
import { FormBuilder, Validators } from '@angular/forms';
var LocationsMoveDialogComponent = /** @class */ (function () {
    function LocationsMoveDialogComponent(data, dialogRef, fb) {
        this.data = data;
        this.dialogRef = dialogRef;
        this.fb = fb;
        this.form = this.createForm(this.data.orderLocations.length);
    }
    Object.defineProperty(LocationsMoveDialogComponent.prototype, "newPositionControl", {
        get: function () {
            return this.form.get('newPosition');
        },
        enumerable: true,
        configurable: true
    });
    LocationsMoveDialogComponent.prototype.onClose = function () {
        this.dialogRef.close();
    };
    LocationsMoveDialogComponent.prototype.onConfirm = function () {
        this.dialogRef.close(this.newPositionControl.value - 1);
    };
    LocationsMoveDialogComponent.prototype.onToFirst = function () {
        this.dialogRef.close(0);
    };
    LocationsMoveDialogComponent.prototype.onToLast = function () {
        this.dialogRef.close(this.data.orderLocations.length);
    };
    LocationsMoveDialogComponent.prototype.orderLocationName = function (orderLocation) {
        var location = orderLocation.location;
        return location.name;
    };
    LocationsMoveDialogComponent.prototype.createForm = function (amountOfOrderLocations) {
        return this.fb.group({
            newPosition: [
                null,
                Validators.compose([
                    Validators.required,
                    Validators.min(1),
                    Validators.max(amountOfOrderLocations)
                ])
            ]
        });
    };
    return LocationsMoveDialogComponent;
}());
export { LocationsMoveDialogComponent };
